



















































import { Component, Vue } from "vue-property-decorator";
import * as firebase from "firebase/app";
import "firebase/auth";

@Component
export default class Login extends Vue {
    name = "Login";
    password = "";
    email = "";
    showError = false;
    errorTimeout = 2000;

    get userDataFetched(): boolean {
        return this.$store.state.user;
    }

    mounted() {
        if (localStorage.email !== undefined) {
            this.email = localStorage.email;
        }
    }

    login() {
        firebase
            .auth()
            .signInWithEmailAndPassword(this.email, this.password)
            .catch(() => {
                this.showError = true;
                this.password = "";
            });
    }
}
